import type { EChartsCoreOption } from 'echarts/core';

type GetGridOptionsReturnType = EChartsCoreOption['grid'];

export const getGridOptions = (): GetGridOptionsReturnType => {
  return {
    left: 0,
    right: 0,
    top: 2,
    bottom: 2,
  };
};
